import { render, staticRenderFns } from "./memorialComment.vue?vue&type=template&id=ba55cca6"
import script from "./memorialComment.vue?vue&type=script&lang=js"
export * from "./memorialComment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports